<template>
  <div class="behavior-feature-wrap">
    <Widgest isOpenAll widgestType="outer" :isBig="true">
      <template v-slot:title>{{$t('report.analyse.behavior.title')}}</template>
      <div class="three-behavior">
        <sand-no-data v-if="convertSignature.length === 0" />
        <SandGradeCollapseGroup
          v-else
          v-for="item in convertSignature"
          :data="item"
          :key="item.title">
          <template v-slot="{ childrenData }">
            <div class="attck-id" v-if="attackidSep(childrenData.attackid).length > 0">
              <span>ATT&CK ID：</span>
              <span
                v-for="(id, index) in attackidSep(childrenData.attackid)"
                :key="index"
                @click="attckClick(id, index, childrenData)"
                class="attck-id-item"
              >{{id}}</span>
            </div>
            <SandTable
              v-if="childrenData.marks[0] && childrenData.marks[0].type !== 'event'"
              class="attck-table"
              :data="handleTableData(childrenData.marks)"
            />
            <div v-else style="padding: 0 20px;">
              <BehaviorEvents :events="childrenData.marks" />
            </div>
          </template>
        </SandGradeCollapseGroup>
      </div>
      <MitreDetailDialog
        :visible="mitreShow"
        :attack="attck"
        :sigs="sigs"
        :loading="loading"
        :show-detail="showDetail"
        @update:visible="mitreShow = $event"
        @update:showDetail="showDetail = $event"
      />
    </Widgest>
  </div>
</template>

<script>
// 分析概览中行为判定模块
// import mitre from 'utils/lib/AttckData'
// import mitreEn from 'utils/lib/AttckData.en-US.js'
import cloneDeep from 'lodash/cloneDeep'
import SandGradeCollapseGroup from '@/components/report/sandGradeCollapseGroup'
import SandTable from '@/components/report/sandTable'
import sandNoData from '@/components/report/sandNoData'
import BehaviorEvents from './BehaviorEvents'
import MitreDetailDialog from 'components/report/MitreDetailDialog.vue' // 引入新组件
// import BehaviorSignature from '@/components/report/behaviorSignature'
import keyMap from '@/assets/mock/eventdesc.json'
import { useI18n } from 'vue-i18n'
import { t, isZh } from 'app/i18n'
import { getAttackInfo } from 'services/report'

export default {
  name: 'BehaviorFeature',
  components: {
    SandGradeCollapseGroup,
    SandTable,
    sandNoData,
    BehaviorEvents,
    MitreDetailDialog
    // BehaviorSignature
  },
  props: {
    behaviorfeature: {
      type: Object
    },
    mitre: {
      type: Array
    }
  },
  computed: {
    isZhcn() {
      const i18n = useI18n()
      return i18n.locale.value !== 'en'
    },
    signatures () {
      return this.behaviorfeature.signatures
    },
    signatures_genre () {
      return this.behaviorfeature.signatures_genre
    },
    convertSignature () {
      return this.signatures_genre.map(item => {
        return {
          title: this.isZhcn ? item.titlezhcn : item.titleenus,
          lockData: item.count,
          childrenData: item.data.sort((a, b) => {
            return b.severity - a.severity
          }).map(item2 => {
            return {
              title: `${this.isZhcn ? item2.descripzhcn : item2.description} (${t('report.analyse.indicator.marks', [item2.marks.length])})`,
              type: item2.severity === 1 ? 'low' : (item2.severity === 2 ? 'middle' : 'high'),
              desc: this.isZhcn ? item2.descripzhcn : item2.description,
              severity: item2.severity,
              childrenData: {
                marks: item2.marks,
                attackid: item2.attackid,
                ids: item2.attack_id_list
              }
            }
          })
        }
      })
    },
    sigs() {
      const ret = {}
      if (this.signatures) {
        this.signatures.forEach((ele) => {
          if (ele.attackid && ele.attackid !== ' ') {
            ele.attackid.split(',').forEach((id) => {
              const trimmedId = id.trim()
              if (ret[trimmedId] === undefined) {
                ret[trimmedId] = []
              }
              // 查找技术点名称
              let techName = ''
              this.mitre.forEach(tactic => {
                const foundTech = tactic.attack_list.find(tech => tech.attackid === trimmedId)
                if (foundTech) {
                  techName = foundTech.name
                }
              })
              // 添加技术点信息
              ret[trimmedId].push({
                id: trimmedId,
                desc: isZh() ? ele.descripzhcn : ele.description,
                severity: ele.severity,
                name: techName
              })

              // 处理子技术点的父技术点
              if (trimmedId.includes('.')) {
                const parentId = trimmedId.split('.')[0]
                if (ret[parentId] === undefined) {
                  ret[parentId] = []
                }
                ret[parentId].push({
                  id: trimmedId,
                  desc: isZh() ? ele.descripzhcn : ele.description,
                  severity: ele.severity,
                  name: techName // 子技术点使用自己的名称
                })
              }
            })
          }
        })
      }
      return ret
    },
    mitreMaxLen () {
      return this.showAttckMitre.map(item => item.techiques.length).reduce((prev, cur) => Math.max(prev, cur), 0)
    },
    showAttckMitre () {
      return this.showAll ? this.mitre : this.attckMitre
    },
    attckMitre () {
      let list = []
      let list2 = []
      for (const i in this.sigs) {
        list = list.concat(this.sigs[i])
      }
      list2 = this.mitre.map(item => {
        return {
          ...item,
          techiques: item.techiques.filter(item2 => list.find(item3 => item3.id === item2.id))
        }
      })
      return list2
    }
  },
  data () {
    return {
      seprateData: [],
      mitreShow: false,
      // mitre: isZh() ? mitre : mitreEn,
      showAll: false,
      attck: null,
      showDetail: false,
      sev: {
        blue: 'informative',
        warning: 'suspicious',
        error: 'malicious'
      },
      keyMap,
      loading: false
    }
  },
  methods: {
    attackidSep (str) {
      if (str) {
        return str.split(',')
      } else {
        return []
      }
    },
    attckClick(t, index, data) {
      if (!t || !this.sigs[t]) return
      this.mitreShow = true
      this.loading = true
      getAttackInfo({
        id: data.ids[index],
        attackid: t,
        taskid: this.$route.params.taskId
      }).then(res => {
        this.loading = false
        this.showDetail = true
        this.attck = res
      })
    },
    tagCalc (id) {
      var ret = {
        blue: 0,
        warning: 0,
        error: 0
      }
      if (this.sigs && this.sigs[id]) {
        this.sigs[id].forEach(function (ele) {
          if (ele.severity === 1) {
            ret.blue++
          } else if (ele.severity === 2) {
            ret.warning++
          } else if (ele.severity >= 3) {
            ret.error++
          }
        })
      }
      return ret
    },
    handleTableData (list) {
      if (list.length === 0) {
        return { columnData: [], tableData: [] }
      }
      const copyList = cloneDeep(list)
      let columnData
      let tableData
      const type = copyList[0].type
      if (type === 'call') {
        // 带表头的横向表格
        columnData = [
          {
            prop: 'time',
            label: this.isZhcn ? '时间' : 'TIME',
            col: 2
          }, {
            prop: 'arguments',
            label: this.isZhcn ? '参数' : 'ARGUMENTS',
            col: 3
          }, {
            prop: 'status',
            label: this.isZhcn ? '状态' : 'STATUS'
          }, {
            prop: 'return_value',
            label: this.isZhcn ? '返回值' : 'RETURN'
          }, {
            prop: 'pid',
            label: this.isZhcn ? '进程' : 'PROCESS'
          }, {
            prop: 'tid',
            label: this.isZhcn ? '线程' : 'THREAD'
          }, {
            prop: 'repeated',
            label: this.isZhcn ? '重复' : 'REPEATED'
          }
        ]
        tableData = copyList.map(item => ({
          ...item.call,
          time: `<span>${item.call.time}</span><br /><span style="font-weight: bold;">${item.call.api}</span>`,
          arguments: Object.keys(item.call.arguments).map(key => {
            return `<span>${key}: ${item.call.arguments[key]}</span>`
          }).join('<br/>'),
          status: item.call.status ? t('success') : t('failed')
        }))
      } else if (type === 'generic') {
        // 纵向表头
        const result = copyList.map(item => {
          delete item.type
          return item
        })
        columnData = Object.keys(result[0]).map(item => ({
          prop: item,
          label: this.isZhcn ? (this.keyMap[item]?.zhcn || item) : this.keyMap[item]?.enus,
          titleWidth: '120'
        }))
        tableData = result
      } else {
        columnData = [{
          prop: 'ioc',
          label: this.isZhcn ? (this.keyMap[copyList[0].category]?.zhcn || copyList[0].category) : this.keyMap[copyList[0].category]?.enus || copyList[0].category,
          titleWidth: '120'
        }]
        tableData = copyList
      }
      return { columnData, tableData, tableProps: { isHorizontal: type !== 'call' } }
    },
    convertBorder (obj) {
      if (obj.error) {
        return 'red'
      } else if (obj.warning) {
        return 'orange'
      } else if (obj.blue) {
        return 'blue'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.behavior-feature-wrap  {
  .three-behavior  {
    .attck-id  {
      font-size: 14px;
      margin: 0px 20px 16px;
      color: var(--color-text-2);
      .attck-id-item  {
        color: #00ab7a;
        cursor: pointer;
        margin-right: 5px;
        &:hover  {
          filter: brightness(1.2);
        }
      }
    }
    .attck-table  {
      margin: 0 20px;
    }
  }
}
:deep(.attck-dialog-class) {
  height: 600px;
  .el-dialog__body {
    padding: 0 24px 0 0;
  }
}
</style>
